import { FC } from 'react';
import { useSnackbar } from 'notistack';
import { Button, Tab, Tabs } from '@mui/material';
import SearchInput from 'src/components/Items/input/SearchInput';
import SPButtons from './SPButtons';

const filterData = ['hosts', 'locations', 'pickup details', 'oneways', 'season price', 'sub price'];

interface IProps {
  tab: number;
  setTab: (tab: number) => void;
  openDelAll: boolean;
  setOpenDelAll: (openDelAll: boolean) => void;
  SPforDelete: number[];
  setSPforDelete: (SPforDelete: number[]) => void;
  setOpenModal: (open: boolean) => void;
  setSearchByLocation: (search: string) => void;
  handleChangeModal: (isOpen: boolean) => void;
}

const AdminFilter: FC<IProps> = ({
  tab,
  openDelAll,
  SPforDelete,
  setTab,
  setOpenDelAll,
  setSPforDelete,
  setOpenModal,
  setSearchByLocation,
  handleChangeModal
}) => {
  const { enqueueSnackbar } = useSnackbar();

  const handleOpenModal = () => {
    if (SPforDelete.length) setOpenModal(true);
    else enqueueSnackbar('Please select season prices', { variant: 'error' });
  };

  const handleCloseDelAll = () => {
    setOpenDelAll(false);
    setSPforDelete([]);
  };

  return (
    <div className='order-table__filter'>
      <Tabs
        selectionFollowsFocus
        onChange={(e, v) => setTab(v)}
        value={tab}
        indicatorColor='secondary'
      >
        {filterData.map((name, i) => (
          <Tab label={name} key={i} />
        ))}
      </Tabs>
      <div className='action-block' style={{ gap: '10px' }}>
        {tab === 5 && <SearchInput setSearch={setSearchByLocation} placeholder='Enter location' />}
        {tab === 4 && (
          <SPButtons
            openDelAll={openDelAll}
            setOpenDelAll={setOpenDelAll}
            handleOpenModal={handleOpenModal}
            handleCloseDelAll={handleCloseDelAll}
          />
        )}
        <Button variant='contained' onClick={() => handleChangeModal(true)}>
          Add {tab === 0 || tab === 1 ? filterData[tab].slice(0, -1) : filterData[tab]}
        </Button>
      </div>
    </div>
  );
};
export default AdminFilter;
